<template>
    <!-- ---------------------------------- 2D体验馆 ---------------------------------- -->
    <div class="experience">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 海报图 ---------------------------------- -->
        <div class="banner">
            <p>抱绿享乐·智慧生活</p>
        </div>
        <!-- ---------------------------------- 标语 ---------------------------------- -->
        <div class="slogan">
            <p>
                2D体验馆 — 方便快捷在线小功能，帮您提前规划空气净化器<br />放置的位置，为你创建个人化的房间，检视产品的细节。
            </p>
        </div>
        <!-- ---------------------------------- 主体内容 ---------------------------------- -->
        <div class="content">
            <!-- 展现图片 -->
            <div class="content_show">
                <div>
                    <img
                        src="../assets/images/15fd712aa475cbc52960cfd03197edd.jpg"
                        v-if="p === false"
                        alt=""
                        class="noneYd"
                    />
                    <el-image
                        class="noneYd_img"
                        fit="fill"
                        v-if="p === true"
                        :src="
                            'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                            productList2[0].pic
                        "
                    ></el-image>
                    <em
                        class="drop"
                        ref="dropImg"
                        v-for="(item, index) in productList_s"
                        v-if="item.checked"
                        @mousedown="downdrop($event, item)"
                        @mousemove="mousemove($event)"
                        @mouseup="upDrop()"
                        @mouseleave="mouseLeave"
                        @touchmove.prevent="touchmove"
                        @touchstart="touchstart(item)"
                        @touchend="touchend"
                        @touchcancel="touchcancel"
                        :style="{
                            backgroundImage:
                                'url(http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item.pic +
                                ')',
                        }"
                    ></em>
                    <br style="clear: both" />
                </div>
            </div>
            <!-- 上传照片 -->
            <div class="upload">
                <div class="up_left">
                    <p class="upload_title">上传照片</p>
                    <el-upload
                        class="upload-demo"
                        :action="url"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        multiple
                        :on-exceed="handleExceed"
                        :on-success="handlePreview"
                        :beforeDestroy="handlePreview"
                        :file-list="fileList"
                        :showFileList="false"
                    >
                        <img
                            class="upload_pic"
                            v-if="p === false"
                            src="../assets/images/15fd712aa475cbc52960cfd03197edd.jpg"
                        />
                        <el-image
                            class="noneYd_img"
                            fit="fill"
                            v-if="p === true"
                            :src="
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                productList2[0].pic
                            "
                        ></el-image>
                    </el-upload>
                    <span
                        >说明：上传照片且选中设备后，可以在指定区域移动该设备</span
                    >
                </div>

                <div class="up_right">
                    <p class="upload_model">所选型号</p>
                    <div
                        style="border: 1px solid #e8e8e8; position: relative"
                        class="mediaupload"
                    >
                        <div class="up_select" id="jhq" v-if="!pdFlag">
                            请选择净化器
                        </div>
                        <div
                            class="model_pic"
                            v-for="(item, index) in productList_s"
                            v-if="active == index && item.checked"
                            id="shut1"
                        >
                            <img
                                class="pic_show"
                                :src="
                                    'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                    item.pic
                                "
                            />
                            <img
                                class="shut"
                                src="../assets/images/icon/icon-x.png"
                                @click="deleteImg(item, index)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ---------------------------------- 产品选择 ---------------------------------- -->
        <div class="product_box">
            <el-tabs type="border-card">
                <el-tab-pane>
                    <div slot="label">
                        <img
                            class="product_tabs"
                            src="../assets/images/icon/renoud-logo-blue.png"
                            mode="widthFix"
                            alt=""
                        />
                    </div>
                    <!-- 产品 -->
                    <div class="product_main" id="product">
                        <div
                            v-for="(item, index) in productList"
                            :class="{
                                main_box: true,
                                active_box: item.checked,
                            }"
                            :key="index"
                            @click="selectItem(item, index)"
                        >
                            <img
                                :src="
                                    'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                    item.pic
                                "
                            />
                            <div class="product_model">{{ item.model }}</div>
                            <div class="product_title">{{ item.title }}</div>
                        </div>
                        <!-- 箭头 -->
                        <div class="arrow_box">
                            <img
                                src="../assets/images/icon/arrow-right.png"
                                alt=""
                                style="width: 100%; height: 94px"
                            />
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer';
import Axios from 'axios';
export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            url: 'http://118.89.87.102:8080/jeecg-boot/sys/common/upload',
            fileUrl: '',
            fileList: [],
            selectColorList: [
                '#fff',
                '#565450',
                '#e0e0d8',
                '#e4e2c8',
                '#bae1e0',
            ],
            selectUrl: '',
            active: -1,
            productList: [],
            productList_s: [],
            productList2: [],
            p: false,
            isDown: false,
            startX: 0,
            startY: 0,
            endX: 0,
            endY: 0,
            pdFlag: false,
        };
    },
    created() {
        this.getBrandList();
    },
    mounted() {
        // this.selectItem(this.productList[0],0);
    },
    methods: {
        touchend() {
            this.isDown = false;
        },
        /** 松开事件 **/
        touchcancel() {
            this.isDown = false;
        },
        /** 按下事件 **/
        touchstart(item) {
            this.active = this.productList_s.findIndex(
                (obj) => obj.time == item.time
            );
            this.isDown = true;
        },
        touchmove(e) {
            if (this.isDown) {
                //算出鼠标相对元素的位置
                // let disX = event.touches[0].clientX - odiv.offsetLeft;
                // let disY = event.touches[0].clientY - odiv.offsetTop;
                if (e.target.localName == 'em') {
                    let odiv = e.target; //获取目标元素
                    let left =
                        e.touches[0].pageX -
                        document.getElementsByClassName('content_show')[0]
                            .offsetLeft -
                        odiv.clientWidth / 2;
                    let top =
                        e.touches[0].pageY -
                        document.getElementsByClassName('content_show')[0]
                            .offsetTop -
                        odiv.clientHeight / 2 -
                        10;
                 
                    //绑定元素位置到positionX和positionY上面
                    let width =
                        document.getElementsByClassName('content_show')[0]
                            .clientWidth -
                        document.getElementsByClassName('drop')[0].clientWidth;
                    let height =
                        document.getElementsByClassName('content_show')[0]
                            .clientHeight -
                        document.getElementsByClassName('drop')[0].clientHeight;

                    //移动当前元素
                    if (left > width) {
                        left = width;
                    } else if (left <= 0) {
                        left = 0;
                    }
                    if (top <= 0) {
                        top = 0;
                    } else if (top >= height) {
                        top = height;
                    }
                    odiv.style.left = left + 'px';
                    odiv.style.top = top + 'px';
                }
                document.ontouchend = (e) => {
                    document.ontouchmove = null;
                    document.ontouchend = null;
                };
            }
        },
        deleteImg(item, index) {
            item.checked = false;
            this.productList_s.forEach((obj, index) => {
                if (obj.checked) {
                    this.active = index;
                }
            });
            let modepic = document.getElementById('shut1');
            let jhqObj = document.getElementById('jhq');
            modepic.onclick = function () {
                jhqObj.style.display = 'block';
            };
            this.pdFlag = this.productList_s.some((ele) => ele.checked);
        },
        getBrandList() {
            this.productList = [];
            Axios.get(
                `${this.api.ip}/jeecg-boot/h5/H5Controller2/queryBrandList`
            ).then((res) => {
                if (res.data.result.length > 0) {
                    this.productList = res.data.result.map((item) => {
                    
                            return {
                            pic: item.brandUrl,
                            model: item.brandCn,
                            title: item.backup1,
                            checked: false,
                        };
                        
                    });
                    if (this.productList.length > 0) {
                        this.active = 0;
                        this.selectUrl = this.productList[0].pic;
                    }
                }
            });
        },
        handleRemove(file, fileList) {
        },
        handlePreview(file, fileList) {
            this.fileUrl = fileList.response.message;
            var that = this;
            that.productList2 = [];
            that.productList2.push({
                pic: file.message,
            });
            that.p = true;
        },
        handleExceed(files, fileList) {
            this.$message.warning(`只能上传一个文件，请先移除多余的文件`, 1);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        /** 选择某一个机器 **/
        selectItem(item, index) {
            // this.$set(item,"time",new Date().getTime());
            let _item = {
                time: new Date().getTime(),
                checked: true,
                model: item.model,
                pic: item.pic,
                title: item.title,
            };
            this.productList_s.push(_item);
            this.active = this.productList_s.length - 1;
            let jhqObj = document.getElementById('jhq');
            let productObj = document.getElementById('product');
            productObj.onclick = function () {
                jhqObj.style.display = 'none';
            };
        },
        mousemove(e) {
            if (this.isDown) {
                let odiv = e.target; //获取目标元素
                //算出鼠标相对元素的位置
                let disX = e.clientX - odiv.offsetLeft;
                let disY = e.clientY - odiv.offsetTop;
                document.onmousemove = (e) => {
                    //鼠标按下并移动的事件
                    //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                    let left = e.clientX - disX;
                    let top = e.clientY - disY;

                    //绑定元素位置到positionX和positionY上面
                    let width =
                        document.getElementsByClassName('content_show')[0]
                            .clientWidth -
                        document.getElementsByClassName('drop')[0].clientWidth;
                    let height =
                        document.getElementsByClassName('content_show')[0]
                            .clientHeight -
                        document.getElementsByClassName('drop')[0].clientHeight;

                    //移动当前元素
                    if (left > width) {
                        left = width;
                    } else if (left <= 0) {
                        left = 0;
                    }
                    if (top <= 0) {
                        top = 0;
                    } else if (top >= height - 50) {
                        top = height - 50;
                    }
                    odiv.style.left = left + 'px';
                    odiv.style.top = top + 'px';
                };
                document.onmouseup = (e) => {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            }
        },
        mouseLeave() {
            this.isDown = false;
        },
        /** 松开事件 **/
        upDrop(ev) {
            this.isDown = false;
        },
        /** 按下事件 **/
        downdrop(ev, item) {
            this.active = this.productList_s.findIndex(
                (obj) => obj.time == item.time
            );
            this.isDown = true;
        },
    },
};
</script>

<style lang="less" scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

// ---------------------------- 海报图 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .banner {
        p {
            font-size: 86px;
        }
    }
}

// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .banner {
        p {
            font-size: 66px;
        }
    }
}

.banner {
    width: 100%;
    // height: 557px;
    background: url('../assets/images/2d-banner.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    padding-bottom: 2%;

    p {
        color: #112653;
        text-align: center;
        letter-spacing: 15px;
        margin: 0;
        padding-top: 19%;
    }
}

// ---------------------------- 标语 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .slogan {
        p {
            font-size: 48px;
            padding-bottom: 2%;
        }
    }
}

// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .slogan {
        p {
            font-size: 36px;
            font-weight: lighter;
        }
    }
}

.slogan {
    width: 100%;
    height: 290px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('../assets/images/2d-blue-bg.png') no-repeat;
    background-size: 100% 101%;
    background-position: center;
    text-align: center;

    p {
        color: #ffffff;
        letter-spacing: 5px;
        margin: 0;
        text-align: center;
        line-height: 1.8;
    }
}

// ---------------------------- 主体内容 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .content {
        width: 100%;

        // 展现图片
        .content_show {
            margin: 0 auto;
            margin-bottom: 80px;
        }

        // 上传照片
        .upload {
            width: 80%;
            display: flex;
            justify-content: center;
            margin: 0 auto;

            // 标题
            .upload_title {
                font-size: 52px;
            }

            // 缩略图
            .up_left {
                width: 30%;
                margin-right: 15%;
                font-size: 40px;
            }

            span {
                font-size: 40px;
            }

            // 所选型号
            .up_right {
                width: 30%;
            }

            .upload_model {
                font-size: 52px;
            }

            .up_select {
                width: 100%;
                position: absolute;
                left: 0%;
                margin: auto;
                top: 45%;
                font-size: 46px;
            }
        }
    }
   .main_box {
            border: 1px solid #b9b9bb;
            width: 18% !important;
            padding: 20px 0;
            border-radius: 10px;
            margin: 0 10px;
            cursor: pointer;
            transition: 0.3s;

            &:hover {
                border: 1px solid #7acdd3;
            }

            // 产品图片
            img {
                height: 280px !important;
                margin: 0 auto;
                display: flex;
            }
        }
    .model_pic {
        width: 100%;
        height: 500px;
        // background-color: #cccccc;

        .pic_show {
            height: 100%;
        }
    }
    .product_model,.product_title{
        font-size: 34px !important;
    }
     .product_box .arrow_box{
                padding-left: 17% !important;
        }
           // 标签
    .product_tabs {
        width: 0.972917rem !important ;
         
    
    
    }
    
.product_box
    /deep/
    .el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item.is-active {
    background-color: #fff;
    border-top: 1px solid #e4e7ed;
    border-left: 1px solid #e4e7ed;
    margin-right: 20px;
    border-radius: 10px 10px 0 0;
    height: 0.5125rem !important;

}   
}

// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .content {
        display: flex;
        justify-content: space-between;
        width: 80%;
    }

    // 上传照片
    .upload {
        width: 27%;

        // 标题
        .upload_title {
            font-size: 22px;
        }

        span {
            font-size: 20px;
        }

        // 所选型号
        .upload_model {
            font-size: 22px;
        }

        .up_select {
            position: absolute;
            left: 37%;
            margin: auto;
            top: 45%;
            font-size: 16px;
        }
    }

    .model_pic {
        height: 100%;

        .pic_show {
            height: 90%;
        }
    }
     // 标签
    .product_tabs {
        width: 120px !important;
        padding: 0 20px 0 20px !important;
        // margin-top: -10px;
        padding: 10px !important;
    }
    
.product_box
    /deep/
    .el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item.is-active {
    background-color: #fff;
    border-top: 1px solid #e4e7ed;
    border-left: 1px solid #e4e7ed;
    margin-right: 20px;
    border-radius: 10px 10px 0 0;
    height: 60px !important;

}   


}

.content {
    margin: 0 auto;
    padding-top: 70px;

    // 展现图片
    .content_show {
        width: 70%;
        margin-top: 40px;
        position: relative;

        .noneYd {
            width: 100%;
            height: 100%;
            -moz-user-select: none;
            -webkit-user-select: none;
            -ms-user-select: none;
            -khtml-user-select: none;
            user-select: none;
            object-fit: contain;
        }

        .noneYd_img {
            // position: absolute;
            width: 100%;
            height: 100%;
            z-index: -1;
        }

        .drop {
            position: absolute;
            width: 200px;
            height: 300px;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            z-index: 99;
            left: 50px;
            bottom: 50px;

            .modelImg {
                position: absolute;
                width: 100%;
                height: 100%;
                z-index: 999;
                cursor: pointer;
            }

            img {
                width: 100%;
                z-index: -1;
            }
        }
    }

    // 上传照片
    .upload {
        // 标题
        .upload_title {
            color: #898584;
            margin: 0;
        }

        // 缩略图
        .upload_pic {
            width: 100%;
            margin: 15px 0 15px 0;
        }

        span {
            color: #333333;
            margin: 0;
        }

        // 所选型号
        .upload_model {
            color: #898584;
            margin: 5px 0 10px 0;
        }

        .model_pic {
            padding: 40px 0;
            border: 1px solid #d8d8d8;
            text-align: center;
            // margin: 10px 0;
            position: relative;
            overflow: hidden;
            background: #fff;
            .shut {
                cursor: pointer;
                width: 30px;
                float: right;
                position: absolute;
                top: 20px;
                right: 20px;
            }
        }

        // 选择颜色
        .select_color {
            width: 100%;
            padding: 10px 0;

            // 标题
            .select_title {
                color: #898584;
                font-size: 20px;
                font-family: 微软雅黑;
                font-weight: 500;
            }

            .select_main {
                width: 100%;
                padding-top: 20px;
                display: flex;
                justify-content: center;

                .color_box {
                    padding: 0 30px;
                    margin-top: 15px;

                    .color_main {
                        border: 1px solid #898584;
                        padding: 3% 20px;
                        margin: 5px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}

// ---------------------------- 产品选择 ---------------------------------
.product_box {
    width: 80%;
    margin: 0 auto;
    margin-top: 50px;
    padding-bottom: 60px;

    // 产品
    .product_main {
        display: flex;
        margin-left: 20px;

        .main_box {
            border: 1px solid #b9b9bb;
            width: 16%;
            padding: 20px 0;
            border-radius: 10px;
            margin: 0 10px;
            cursor: pointer;
            transition: 0.3s;

            &:hover {
                border: 1px solid #7acdd3;
            }

            // 产品图片
            img {
                height: 180px;
                margin: 0 auto;
                display: flex;
            }
        }

        .active_box {
            border: 1px solid #7acdd3;
        }

        // 产品型号
        .product_model {
            color: #686868;
            font-size: 20px;
            text-align: center;
            margin-top: 10px;
        }

        // 产品名称
        .product_title {
            color: #686868;
            font-size: 22px;
            text-align: center;
        }
    }

    // 标签
    // .product_tabs {
    //     width: 110px;
    //     padding: 0 20px 0 20px;
    //     margin-top: -10px;
    // }

    // 箭头
    .arrow_box {
        padding-left: 27%;
        align-items: center;
        display: flex;
        // position: absolute;
        // right: 3%;
        // top: 35%;
    }
}

@media screen and (max-height: 1050px) {
    .mediaupload {
        height: 400px;
    }

    .upload_pic {
        // height: 250px;
    }

    .noneYd_img {
        // height: 255px;
    }
}

@media screen and (max-height: 920px) {
    .mediaupload {
        height: 400px;
    }

    .upload_pic {
        // height: 250px;
    }

    .noneYd_img {
        // height: 255px;
    }
}

.product_box /deep/ .el-tabs--border-card {
    background-color: none;
    -webkit-box-shadow: none;
}

// .product_box
//     /deep/
//     .el-tabs--border-card
//     > .el-tabs__header
//     .el-tabs__item.is-active {
//     background-color: #fff;
//     border-top: 1px solid #e4e7ed;
//     border-left: 1px solid #e4e7ed;
//     margin-right: 20px;
//     border-radius: 10px 10px 0 0;
// }

.product_box /deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    background-color: #d3d5d7;
    border-top: 1px solid #e4e7ed;
    border-left: 1px solid #e4e7ed;
    margin-right: 20px;
    border-radius: 10px 10px 0 0;
}

.product_box /deep/ .el-tabs__content {
    background-color: #fff;
    border-right: 1px solid #dcdfe6;
    border-left: 1px solid #dcdfe6;
}

.product_box /deep/ .el-tabs--border-card > .el-tabs__header {
    background-color: #fff;
}

.product_box /deep/ .el-tabs--border-card {
    border-top: none;
    border-right: none;
    border-left: none;
}

.product_box /deep/ .el-tabs__nav {
    border-left: 1px solid #fff;
    border-top: 1px solid #fff;
}

.product_box /deep/ .el-tabs--border-card {
    background-color: none;
}

#product .main_box:nth-child(4){
display: none;
}
#product .main_box:nth-child(3){
display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/experience.vue